export default __webpack_public_path__ + "static/media/font.cc0deba4.svg";